import React, { useEffect } from "react";
import { useRef } from "react";
import SubHeader from "../components/subheader";
import Models from "../components/exampleModels";
import { Features, Range } from "../components/features";
import Payment from "../components/payment";

const LandingPage = ({ onPlanSelect, setPage }) => {
  const driverRef = useRef(null);
  const trackRef = useRef(null);

  // Scroll to the driver section of the landing page
  const scrollToDriver = () => {
    driverRef.current?.scrollIntoView({ behaviour: "smooth" });
  };

  // Scroll to the circuit section of the landing page
  const scrollToTrack = () => {
    trackRef.current?.scrollIntoView({ behaviour: "smooth" });
  };

  // Returning all landing page components.
  return (
    <div className="landing-page">
      <SubHeader
        onDriversClick={scrollToDriver}
        onTracksClick={scrollToTrack}
      />
      <Models />
      <Features />
      <Range driverRef={driverRef} trackRef={trackRef} />
      <Payment onPlanSelect={onPlanSelect} setPage={setPage} />
    </div>
  );
};

export default LandingPage;
